import { render, staticRenderFns } from "./benefitSku.vue?vue&type=template&id=326be2d4&"
import script from "./benefitSku.vue?vue&type=script&lang=js&"
export * from "./benefitSku.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports